export default __webpack_public_path__ + "static/media/featured-collection.72fdd854.jpg";